import { FIRST_SCREEN_EAGER_CARDS_COUNT } from '../../constants/lcp';

/**
 * Режим загрузки главного фото карточки:
 * - `high` — фото в SSR без lazy и с fetchPriority="high": главный кандидат в LCP на странице;
 * - `eager` — фото в SSR без lazy: карточка на первом экране;
 * - `undefined` — фото грузится после гидрации с loading="lazy".
 */
export type TFirstScreenImageMode = 'eager' | 'high';

/**
 * Первые карточки выдачи попадают на первый экран и должны отдавать главное фото в SSR.
 * Если над выдачей показан промо-сниппет, он уже занимает первый экран и несёт LCP-картинку
 * с высоким приоритетом: карточек с eager-фото становится на одну меньше, а `high` не назначается никому.
 */
export function getFirstScreenImageMode(
  position: number,
  isPromoSnippetDisplayed: boolean,
): TFirstScreenImageMode | undefined {
  const eagerCardsCount = isPromoSnippetDisplayed ? FIRST_SCREEN_EAGER_CARDS_COUNT - 1 : FIRST_SCREEN_EAGER_CARDS_COUNT;

  if (position >= eagerCardsCount) {
    return undefined;
  }

  return position === 0 && !isPromoSnippetDisplayed ? 'high' : 'eager';
}
